@if (
  {
    pageInfos: (paginationService.pageInfos$ | async)!
  };
  as context
) {
  <section aria-label="Suchergebnisse" [attr.aria-busy]="bildungsAngeboteLoading$ | async">
    @if (paginationService.showMaxAlert()) {
      <div id="hinweis_max_ergebnisse" class="alert alert-info" role="note" aria-label="Hinweis">
        Es können nur 10.000 Treffer angezeigt werden. Für weitere Treffer ist die Suche
        einzugrenzen oder zu filtern.
      </div>
    }
    <now-wbsuche-lib-mobile-show-filter-button
      [showFacettenFilterbuttonMobil]="(showRequiredInputState$ | async) === false"
    ></now-wbsuche-lib-mobile-show-filter-button>

    @if (showRequiredInputState$ | async) {
      <now-wbsuche-lib-required-inputs-state
        class="d-block mt-3"
      ></now-wbsuche-lib-required-inputs-state>
    } @else {
      @if (context.pageInfos?.totalResults === 0 && (bildungsAngeboteLoading$ | async) === false) {
        <ng-container class="d-block mt-3">
          @if ((this.berufeService.isBerufssuche$ | async) === true) {
            <now-wbsuche-lib-berufe-empty-state></now-wbsuche-lib-berufe-empty-state>
          } @else {
            <now-wbsuche-lib-suchergebnis-empty-state></now-wbsuche-lib-suchergebnis-empty-state>
          }
        </ng-container>
      } @else {
        <now-wbsuche-lib-kompakt-ansicht
          (terminSelected)="terminSelected.emit($event)"
          [loading]="(bildungsAngeboteLoading$ | async)!"
        >
        </now-wbsuche-lib-kompakt-ansicht>
      }
    }

    <!-- Paginierung unten -->
    @if (paginationService.showMaxAlert()) {
      <div
        id="hinweis_max_ergebnisse_unten"
        class="alert alert-info"
        role="note"
        aria-label="Hinweis"
      >
        Es können nur 10.000 Treffer angezeigt werden. Für weitere Treffer ist die Suche
        einzugrenzen oder zu filtern.
      </div>
    }
  </section>
}
